import React from 'react';
import { createRoot } from 'react-dom/client';

import { Shell } from './Shell';

createRoot(document.getElementById('appContainer')).render(<Shell />);
